import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PaginatedJustificationReverseLogistics } from 'contracts/JustificationsReverseLogistics';
import type { Pagination } from 'contracts/Pagination';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_JUSTIFICATIONS_REVERSE_LOGISTICS_',
  }
);

export interface PaginateJustificationsReverseLogisticsState {
  data: PaginatedJustificationReverseLogistics[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateJustificationsReverseLogisticsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedJustificationReverseLogistics[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateJustificationsReverseLogisticsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateJustificationsReverseLogisticsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginateJustificationsReverseLogisticsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginateJustificationsReverseLogisticsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateJustificationsReverseLogisticsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateJustificationsReverseLogistics = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateJustificationsReverseLogisticsTypes = Types;
export const PaginateJustificationsReverseLogisticsActions = Creators;
